import debounce from "lodash.debounce";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";

import { fetchGet, toQueryString } from "../../../../service/api_client";
import AutoCompleteField from "../../../../ui/new_components/common/autocomplete";
import { ItemModelV2 } from "../../../../erp/inventory/models/item_model";
import { extend } from "lodash";
import AutoCompleteFieldWithoutAddNew from "../../../new_components/common/autocomplete/autocomplete_without_add_";

interface ItemModelWithAvailableUnits extends ItemModelV2 {
  available_units?: number;
}

interface ConsumablesSearchFieldProps {
  warehouse_id: string;
  onSelect: (data: ItemModelWithAvailableUnits) => void;
  disabled?: boolean;
  placeholder?: string;
  value?: ItemModelV2;
  id?: string;
}

const ConsumablesSearchField: FunctionComponent<ConsumablesSearchFieldProps> = (
  props
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/orders/get-available-consumables`;
  const { showToast } = useToast();
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [addNew, setAddNew] = useState(false);
  const [data, setData] = useState<ItemModelWithAvailableUnits[]>([]);
  const getData = async (prop: {
    warehouse_id?: string;
    item_name?: string;
  }) => {
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        setData(res.data);
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const debouncedHandler = useCallback(
    debounce((query) => {
      if (query)
        getData({
          warehouse_id: props.warehouse_id,
          item_name: query,
        });
      else setData([]);
    }, 500),
    [props.warehouse_id]
  );

  useEffect(() => {
    if (search && edit) {
      if (props.value && props.value.name === search) return;
      debouncedHandler(search);
    }
  }, [search]);

  useEffect(() => {
    if (
      props.value &&
      props.value !== undefined &&
      Object.keys(props.value).length > 0
    ) {
      setSearch(
        props.value
          ? `${props.value.name}${
              props.value.description ? ` - ${props.value.description}` : ""
            }`
          : ""
      );
    }
  }, [props.value]);

  useEffect(() => {
    if (props.disabled) {
      setEdit(false);
      if (
        props.value &&
        props.value !== undefined &&
        Object.keys(props.value).length > 0
      ) {
        setSearch(
          props.value
            ? `${props.value.name}${
                props.value.description ? ` - ${props.value.description}` : ""
              }`
            : ""
        );
      }
    }
  }, [props.disabled, props.value]);

  return (
    <div className="flex gap-1 items-center    w-full">
      {edit ? (
        <AutoCompleteFieldWithoutAddNew
          id={props.id}
          disabled={props.disabled}
          onAddNew={() => {
            setAddNew(true);
          }}
          loading={loading}
          value={search}
          placeholder={props.placeholder ?? "Select an item "}
          onSelect={(val) => {
            setEdit(false);
            setSearch(
              props.value
                ? `${props.value.name}${
                    props.value.description
                      ? ` - ${props.value.description}`
                      : ""
                  }`
                : ""
            );
            props.onSelect(val.value);
          }}
          suggestions={data?.map((d) => ({
            label: (
              <div className="text-xs">
                <b>
                  {d.name ?? "test"} - {d.description ?? ""}{" "}
                </b>
              </div>
            ),

            value: d,
          }))}
          onChange={setSearch}
        />
      ) : (
        // <div
        //   title={search}
        //   className={`text-xs px-3 py-2 h-8 rounded focus:outline-none w-full border ${
        //     search ? "overflow-x-auto whitespace-nowrap" : "text-gray-400"
        //   }`}
        //   style={{ maxWidth: "100%", overflowY: "hidden", overflowX: "auto" }}
        //   onClick={() => {
        //     if (!props.disabled) {
        //       setEdit(true);
        //     }
        //   }}
        // >
        //   {search || props.placeholder || "Select an item "}
        // </div>

        // Larger Version
        <div
          id={props.id}
          title={search}
          className={`text-sm px-4 py-3 h-12 rounded focus:outline-none w-full border ${
            search ? "overflow-x-auto whitespace-nowrap" : "text-gray-400"
          }`}
          style={{
            maxWidth: "100%",
            overflowY: "hidden",
            overflowX: "auto",
          }}
          onClick={() => {
            if (!props.disabled) {
              setEdit(true);
            }
          }}
        >
          {search || props.placeholder || "Select an item "}
        </div>
      )}
    </div>
  );
};

export default ConsumablesSearchField;
